import { render, staticRenderFns } from "./PdfDownloadButton.vue?vue&type=template&id=6a4b43c4&scoped=true&"
import script from "./PdfDownloadButton.vue?vue&type=script&lang=js&"
export * from "./PdfDownloadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4b43c4",
  null
  
)

export default component.exports